import config from "../../vue.config"
import Panel from '../pages/Panel.vue'

const routes = [
  { path: config.publicPath + "index", component: Panel },
  { path: config.publicPath, component: Panel },
]

export default routes;
